"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  console.error("Client-side error:", error);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 p-6">
      <div className="text-6xl">⚠️</div>
      <h2 className="text-xl font-semibold text-gray-800">
        Something went wrong
      </h2>
      <p className="text-gray-500 text-center max-w-md">
        An unexpected error occurred. Please try again.
      </p>
      <div className="flex gap-3">
        <button
          className="btn btn-primary"
          onClick={() => reset()}
        >
          Try again
        </button>
        <button
          className="btn btn-outline"
          onClick={() => window.location.reload()}
        >
          Reload page
        </button>
      </div>
    </div>
  );
}